import { render, staticRenderFns } from "./chatbot.vue?vue&type=template&id=f0cc6d34&"
import script from "./chatbot.vue?vue&type=script&lang=ts&"
export * from "./chatbot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports